import BreadcrumbLink from '@/shared/ui/components/BreadcrumbLink';
import type { RoutePathDefinition } from '../../types';

export const requestsSectionRoutes: RoutePathDefinition[] = [
  {
    path: '',
    lazy: () => import('@/pages/requests').then(m => ({ Component: m.Requests })),
    handle: { crumb: () => <BreadcrumbLink>Requests</BreadcrumbLink> }
  }
];
